import { PureComponent } from "react";
import * as PropTypes from "prop-types";
import styled from "styled-components";

export default class SearchItem extends PureComponent {
  static propTypes = {
    item: PropTypes.any.isRequired,
    selected: PropTypes.any,
    selectedIndex: PropTypes.number,
    index: PropTypes.number.isRequired,
    onClick: PropTypes.func.isRequired,
    onDoubleClick: PropTypes.func.isRequired,
    id: PropTypes.string,
  };

  static defaultProps = {
    selected: null,
    selectedIndex: -1,
    id: "",
  };

  handleClick = () => {
    this.props.onClick(this.props.item, this.props.index);
  };

  handleDoubleClick = () => {
    this.props.onDoubleClick(this.props.item, this.props.index);
  };

  render() {
    const { item, index } = this.props;

    return (
      <ItemContainer
        id={this.props.id}
        onClick={this.handleClick}
        // onTouchEnd={this.handleClick} causes handleclick events to be executed twice on mobile, causes bug on praktijk selecten, find different solution
        onDoubleClick={this.handleDoubleClick}
        selected={
          this.props.selected === item || index === this.props.selectedIndex
        }
        key={`${item}${item.key}`}
      >
        <ItemWrapper>{item}</ItemWrapper>
      </ItemContainer>
    );
  }
}

const ItemContainer = styled.div`
  user-select: none;
  border-bottom: solid 1px ${({ theme }) => theme.dividerColor};
  cursor: pointer;
  &:last-child {
    border-bottom: none;
  }
  &:hover {
    background-color: ${({ theme }) => theme.hoverColor};
  }
  ${({ selected, theme }) =>
    selected && `background-color ${theme.selectedColor};`};
`;

const ItemWrapper = styled.div`
  padding: 0.5rem;
`;
